import invariant from 'invariant';

import { configString } from 'utils/config';
import { isNotEmpty } from 'utils/functional';

// HACK(arnav): It appears the flow type for actionDateFacet is not correct
// in the flow settings.
const getVolopsSearchIndex = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  actionDateFacet?: Record<string, any> | null | undefined,
  sort?: string | null | undefined
) => {
  const volopsIndexName = configString('algolia', 'volopsIndexName');
  invariant(isNotEmpty(volopsIndexName), 'volopsIndexName cannot be empty');
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-nested-ternary
  return actionDateFacet && (actionDateFacet.starts || actionDateFacet.ends)
    ? `${volopsIndexName}-starts-asc`
    : sort === 'relevance'
    ? volopsIndexName
    : `${volopsIndexName}-published-desc`;
};

export default getVolopsSearchIndex;
